exports.cs = {
  NO_DATA: 'Pro daný fond nebyla nalezena žádná data.',
  TITLE: 'Cenné papíry',
  CZK: 'Kč',
  NAME: 'Název',
  TYPE: 'Druh',
  REPRESENTATION: 'Zastoupení',
  ISIN: 'ISIN'
}
